export default __webpack_public_path__ + "static/media/Cord of the Cackling Marionette.159fa720.jpg";